import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'


const Switch = ({
  checked,
  onChange,
  disabled = false,
  label,
  id,
  size = 'md',
  className = ''
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return {
          container: 'w-9 h-5',
          toggle: 'w-4 h-4',
          translate: 'translate-x-4'
        }
      case 'lg':
        return {
          container: 'w-14 h-7',
          toggle: 'w-6 h-6',
          translate: 'translate-x-7'
        }
      default: // md
        return {
          container: 'w-11 h-6',
          toggle: 'w-5 h-5',
          translate: 'translate-x-5'
        }
    }
  }

  const sizeClasses = getSizeClasses()

  const getBackgroundColor = () => {
    if (disabled) {
      return checked ? 'bg-surface' : 'bg-surface'
    }
    return checked ? 'bg-primary-main' : 'bg-surface'
  }

  const getToggleColor = () => {
    if (disabled) {
      return 'bg-white'
    }
    return 'bg-white'
  }

  const handleChange = () => {
    if (!disabled && onChange) {
      onChange(!checked)
    }
  }

  return (
    <div className={classnames('flex items-center gap-3', className)}>
      <button
        type="button"
        id={id}
        onClick={handleChange}
        disabled={disabled}
        className={classnames(
          'relative inline-flex items-center rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-main focus:ring-offset-2',
          sizeClasses.container,
          getBackgroundColor(),
          {
            'cursor-not-allowed opacity-50': disabled,
            'cursor-pointer': !disabled,
            'border-divider': !checked,
            'border-transparent': checked,
          }
        )}
      >
        <span
          className={classnames(
            'pointer-events-none inline-block rounded-full shadow transform ring-0 transition duration-200 ease-in-out',
            sizeClasses.toggle,
            getToggleColor(),
            {
              [sizeClasses.translate]: checked,
              'translate-x-0': !checked
            }
          )}
        />
      </button>
      {label && (
        <label
          htmlFor={id}
          className={classnames(
            'text-sm font-medium cursor-pointer select-none',
            {
              'text-text-secondary cursor-not-allowed': disabled,
              'text-text-primary': !disabled
            }
          )}
          onClick={handleChange}
        >
          {label}
        </label>
      )}
    </div>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string
}

export default Switch